import Swiper from "swiper";
import { Grid, Navigation, Scrollbar } from 'swiper/modules';

function sliderProducts() {
  const sliders = document.querySelectorAll('.products-slider__slider-rows .swiper');
  sliders.forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Grid],
      spaceBetween: 16,
      slidesPerView: 2,
      allowTouchMove: false,
      navigation: {
        prevEl: slider.closest('.products-slider__slider-rows').querySelector('.swiper-button-prev'),
        nextEl: slider.closest('.products-slider__slider-rows').querySelector('.swiper-button-next'),
      },
      grid: {
        rows: 2,
        fill: "row"
      },
      breakpoints: {
        1024: {
          slidesPerView: 4,
          grabCursor: true,
          allowTouchMove: true,
          spaceBetween: 40,
          grid: {
            rows: 1,
            fill: "row"
          },
        }
      }
    });
  });
  const slidersOneRow = document.querySelectorAll('.products-slider__slider-one-row .swiper');
  slidersOneRow.forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar],
      spaceBetween: 16,
      slidesPerView: 2,
      navigation: {
        prevEl: slider.closest('.products-slider__slider-one-row').querySelector('.swiper-button-prev'),
        nextEl: slider.closest('.products-slider__slider-one-row').querySelector('.swiper-button-next'),
      },
      breakpoints: {
        1226: {
          slidesPerView: 4,
          grabCursor: true,
          allowTouchMove: true,
          spaceBetween: 40,
        }
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
    });
  });
}
sliderProducts();
